import { HostListener, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

// Define the Menu interface
export interface Menu {
  title: string;
  path?: string;
  icon?: string;
  type: string;
  active: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService {
  public openclass = false;
  public screenWidth: number = window.innerWidth;
  public collapseSidebarMainMenu = false;
  public collapseSidebarSecondMenu = false;
  public showReport = false;
  public horizontal = window.innerWidth >= 991;
  public fullScreen = false;

  ADMINITEMS: Menu[] = [
    {
      title: "Institute",
      path: "/admin/institute",
      icon: "home",
      type: "sub",
      active: true,
    },
    {
      title: "Level",
      path: "/admin/tertiary-level",
      icon: "graph3",
      type: "sub",
      active: false,
      children: [
        {
          title: "Level Of Membership",
          type: "sub",
          active: true,
          children: [
            { path: "/admin/tertiary-level", title: "Tertiary (1st to 3rd yr)", type: "link", active: false },
            { path: "/admin/high-level", title: "High School (6th to 8th std)", type: "link", active: false },
            { path: "/admin/primary-level", title: "Primary (3rd to 5th std)", type: "link", active: false },
          ],
        },
      ],
    },
    {
      title: "SPOC",
      path: "/admin/spoc",
      icon: "user",
      type: "sub",
      active: false,
    },
    {
      title: "Blog",
      path: "/admin/blogs",
      icon: "menu",
      type: "sub",
      active: false,
    },
    {
      title: "Events",
      path: "/admin/events",
      icon: "menu",
      type: "sub",
      active: false,
    },
    {
      title: "Questionnarie",
      path: "/admin/questionnarie",
      icon: "note2",
      type: "sub",
      active: false,
    },
    {
      title: "Setting",
      path: "/admin/setting",
      icon: "settings",
      type: "sub",
      active: false,
    },
    {
      title: "Student",
      path: "/admin/student",
      icon: "id",
      type: "sub",
      active: false,
    },
    {
      title: "Module Report",
      path: "/admin/reports",
      icon: "graph3",
      type: "sub",
      active: false,
    },

  ];

  INSTITUTEITEMS: Menu[] = []; // will set in constructor

  SPOCITEMS: Menu[] = [
    {
      title: "Institute",
      path: "/spoc/spoc-institute",
      icon: "home",
      type: "sub",
      active: true,
    },
    {
      title: "Blog",
      path: "/spoc/blogs",
      icon: "menu",
      type: "sub",
      active: false,
    },
    {
      title: "Features",
      path: "/spoc/spoc-article",
      icon: "news-paper",
      type: "sub",
      active: false,
    },
  ];

  MENTORITEMS: Menu[] = [
    {
      title: "Mentor-details",
      path: "/mentor/mentor-details",
      icon: "id",
      type: "sub",
      active: true,
    },
    {
      title: "Students",
      path: "/mentor/view-students",
      icon: "users",
      type: "sub",
      active: false,
    },
    {
      title: "Level",
      path: "/mentor/tertiary-mentor/0",
      icon: "graph3",
      type: "sub",
      active: false,
      children: [
        {
          title: "level of Membership",
          type: "sub",
          active: true,
          children: [
            { path: "/mentor/tertiary-mentor/0", title: "Tertiary (1st to 3rd yr)", type: "link", active: false },
            { path: "/mentor/highSchool-mentor/1", title: "High School (6th to 8th std)", type: "link", active: false },
            { path: "/mentor/primary-mentor/2", title: "Primary (3rd to 5th std)", type: "link", active: false },
          ],
        },
      ],
    },
    {
      title: "Features",
      path: "/mentor/viewAllFeatures",
      icon: "news-paper",
      type: "sub",
      active: false,
    },
    {
      title: "Questionnarie",
      path: "/mentor/questionnarie",
      icon: "note2",
      type: "sub",
      active: false,
    },
    {
      title: "Blog",
      path: "/mentor/blogs",
      icon: "menu",
      type: "sub",
      active: false,
    },
  ];

  Admin = new BehaviorSubject<Menu[]>(this.ADMINITEMS);
  Institute = new BehaviorSubject<Menu[]>([]);
  Spoc = new BehaviorSubject<Menu[]>(this.SPOCITEMS);
  Mentor = new BehaviorSubject<Menu[]>(this.MENTORITEMS);

  constructor() {
    this.onResize();

    if (this.screenWidth < 991) {
      this.collapseSidebarMainMenu = false;
      this.collapseSidebarSecondMenu = true;
    }
    this.rebuildMenus();

  }

  @HostListener("window:resize", ["$event"])
  onResize(event?: any) {
    this.screenWidth = window.innerWidth;
  }

  rebuildMenus() {
    this.showReport = localStorage.getItem("demo") == "1";
    const menu: Menu[] = [
      {
        title: "Level",
        path: "/institute/tertiary-institute/0",
        icon: "graph3",
        type: "sub",
        active: false,
        children: [
          {
            title: "level of Membership",
            type: "sub",
            active: true,
            children: [
              { path: "/institute/tertiary-institute/0", title: "Tertiary (1st to 3rd yr)", type: "link", active: false },
              { path: "/institute/high-institute/1", title: "High School (6th to 8th std)", type: "link", active: false },
              { path: "/institute/primary-institute/2", title: "Primary (3rd to 5th std)", type: "link", active: false },
            ],
          },
        ],
      },
      {
        title: "Mentor",
        path: "/institute/mentor",
        icon: "user",
        type: "sub",
        active: false,
      },
      {
        title: "Student",
        path: "/institute/student-viewtable",
        icon: "user",
        type: "sub",
        active: false,
        children: [
          {
            title: "Personal Details",
            type: "sub",
            active: true,
            children: [
              { path: "/institute/student-viewtable", title: "Personal Details", type: "link", active: false },
              { path: "/institute/student-transfer", title: "Student Transfer", type: "link", active: false },
            ],
          },
        ],
      },
      {
        title: "Events",
        path: "/institute/event/myEvents",
        icon: "id",
        type: "sub",
        active: false,
      },
      {
        title: "Features",
        path: "/institute/article/createdArticle",
        icon: "news-paper",
        type: "sub",
        active: false,
      },
      {
        title: "Blog",
        path: "/institute/blogs",
        icon: "menu",
        type: "sub",
        active: false,
      },
      {
        title: "Setting",
        path: "/institute/view-setting",
        icon: "settings",
        type: "sub",
        active: false,
      },
      {
        title: "Questionnaire",
        path: "/institute/questionnarie",
        icon: "note2",
        type: "sub",
        active: false,
      },
      {
        title: "Report",
        path: "/institute/institude-report",
        icon: "graph3",
        type: "sub",
        active: false,
        children: [
          {
            title: "Report",
            type: "sub",
            active: true,
            children: [
              { path: "/institute/institude-report", title: "Performance Report", type: "link", active: false },
              ...(this.showReport ? [{ path: "/institute/module-reports", title: "Module Report", type: "link", active: false }] : []),
            ],
          },
        ],
      },
    ];

    this.Institute.next(menu);
  }

}
